


















import Vue from "vue";
import PreviewContainer from "@/app/modules/work/components/content-cotainer/TheContentContainerPreviewContainer.vue";
import ToolsPanel from "@/app/modules/work/components/content-cotainer/TheContentContainerToolsPanel.vue";
import DownloadPanel from "@/app/modules/work/components/content-cotainer/TheContentContainerDownloadPanel.vue";

export default Vue.extend({
  name: "ContentContainer",
  components: {
    PreviewContainer,
    ToolsPanel,
    DownloadPanel,
  },
  data: function () {
    return {
      topName: "",
    };
  },
  computed: {
    items() {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    showDownloadPanel: function () {
      return this.$store.state.showDownloadPanel;
    },
    uploadToCloud: {
      get: function () {
        return this.$store.state.uploadToCloud;
      },
      set: function (value) {
        this.$store.commit("uploadToCloud", value.toString() == "true");
      },
    },
  },
  watch: {
    previewItem: {
      deep: true,
      handler() {
        if (!this.previewItem) {
          return;
        }
        let isOriginalSize =
          this.previewItem.currentVariation.currentSize.name ===
            this.previewItem.inputSize.name ||
          this.previewItem.currentVariation.currentSize.title === "Original";
        let options = [];
        if (this.previewItem) {
          options.push(
            this.previewItem.currentVariation.currentSize.simpleTitle
          );
          if (!isOriginalSize) {
            options.push(this.previewItem.currentVariation.preset.title);
          }
          if (
            this.previewItem.currentVariation.filter.currentPreset !==
            "Original"
          ) {
            options.push("Filter");
          }
          if (
            this.previewItem.currentVariation.music.file
          ) {
            options.push("Music");
          }
          if (
            this.previewItem.currentVariation.cut.startTime !== 0 ||
            this.previewItem.currentVariation.cut.finishTime !==
              this.previewItem.duration
          ) {
            options.push("Cutted");
          }
          if (this.previewItem.currentVariation.speed !== 1) {
            options.push(
              "Speed " + this.previewItem.currentVariation.speed + "x"
            );
          }
          if (this.previewItem.currentVariation.endCard.packshot) {
            options.push("End Card");
          }
        }
        let optionsString = "";
        options.forEach((o, i) => {
          optionsString +=
            "[" + o + "]" + (i === options.length - 1 ? "" : ", ");
        });
        this.topName = this.previewItem
          ? this.previewItem.name + " / " + optionsString
          : "";
      },
    },
  },
  methods: {},
});
